import {
   getRequest,
   postRequest,
} from "@/utils/api";

// 查询充电订单列表
export function listOrder(params) {
   return postRequest('/api/coo/order/list', params)
}

// 查询充电订单详情
export function getOrder(id) {
   return postRequest('/api/coo/order/get', { id })
}

// 新增充电订单
export function addOrder(data) {
   return postRequest('/api/coo/order/add', data)
}

// 修改充电订单
export function updateOrder(data) {
   return postRequest('/api/coo/order/update', data)
}

// 删除充电订单
export function delOrder(id) {
   return postRequest('/api/coo/order/delete', { id })
}

// 推送充电订单
export function pushOrder(id) {
   return postRequest('/api/coo/order/push', { id })
}

// 批量推送充电订单
export function pushBatchOrder(params) {
   return postRequest('/api/coo/order/push-batch', params)
}

// 查询推送日志
export function getPushLog(orderId) {
   return postRequest('/api/coo/order/push-log', { orderId })
}

// 导入充电订单
export function importOrder(data) {
   return postRequest('/api/coo/order/import', data)
}

// 导出充电订单
export function exportOrder(params) {
   return getRequest('/api/coo/order/export', params)
}

// 下载导入模板
export function downloadOrderTemplate() {
   return getRequest('/api/coo/template/order/template')
}

// 查询推送日志
export function listPushLog(params) {
   return postRequest('/api/coo/push/log/list', params)
}

// 重新推送
export function retryPush(id) {
   return postRequest('/api/coo/push/log/retry', { id })
}
